import { EjariAction } from "@eres/ejari-core/reducers/EjariData";
import { AnyAction } from "redux";
import { EjariContractAction } from "@eres/ejari-core/reducers/EjariContractData";


export enum Actions {
	USER_LOGGED_IN = "USER_LOGGED_IN",
	USER_LOGGED_OUT = "USER_LOGGED_OUT",
	USER_REFRESHING = "USER_REFRESHING",
	LANG_CHANGED = "LANG_CHANGED",
	TOKEN_CHANGED = "TOKEN_CHANGED",
	GUEST_TOKEN_CHANGED = "GUEST_TOKEN_CHANGED",
	UNIT_CHANGED = "UNIT_CHANGED",
	UPDATE_TENANT_ID = "UPDATE_TENANT_ID",
	SHOW_PROFILE_UPDATED = "SHOW_PROFILE_UPDATED",
	VIEW_TYPE_CHANGED = "VIEW_TYPE_CHANGED",
	OWNER_DASHBOARD_VIEW_TYPE_CHANGED = "OWNER_DASHBOARD_VIEW_TYPE_CHANGED",
	VIP_CATEGORY_CHANGED = "VIP_CATEGORY_CHANGED",
	SET_IS_UAE_PASS_USER = "SET_IS_UAE_PASS_USER",
	SET_APPLICATION = "SET_APPLICATION",
	SET_SELETEDPROFILE_ID = "SET_SELETEDPROFILE_ID",
	SET_SHOW_NDA = "SET_SHOW_NDA",
}

export enum SavedLoginAction {
	SAVE_EID = "SLA_SAVE_EID",
	SAVE_OWNER_EID = "SAVE_OWNER_EID",
}

export enum UserDataActions {
	ON_PROPERTIES = "ON_PROPERTIES",
	ON_PROPERTIES_LOADING = "ON_PROPERTIES_LOADING",
	ON_LEASE = "ON_LEASE",
	ON_LEASE_LOADING = "ON_LEASE_LOADING",
	ON_MAP_PROPERTIES = "ON_MAP_PROPERTIES",
	ON_MAP_PROPERTIES_LOADING = "ON_MAP_PROPERTIES_LOADING",
}

export enum TempDataActions {
	ON_LOAD_DATA = "ON_LOAD_DATA",
	ON_LOAD_DATA_DONE = "ON_LOAD_DATA_DONE",
	SHOW_MESSAGE = "SHOW_MESSAGE",
	HIDE_MESSAGE = "HIDE_MESSAGE",
	SHOW_ERROR = "SHOW_ERROR",
	HIDE_ERROR = "HIDE_ERROR",
	LOADER_CSS_CLASS = "LOADER_CSS_CLASS",
	SHOW_INFO = "SHOW_INFO",
}

export default Actions;

export type ActionDispatch = ( data: { type: Actions, payload?: any } ) => void;

export type AppAction = EjariAction | EjariContractAction | AnyAction;
